import { render, staticRenderFns } from "./AdminClientes.vue?vue&type=template&id=98a24764&scoped=true"
import script from "./AdminClientes.vue?vue&type=script&lang=js"
export * from "./AdminClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a24764",
  null
  
)

export default component.exports